export const isAutomatedTestMode = ({
  detectUnitTestsOnly = false,
} = {}): boolean => {
  const isTest = process.env.NODE_ENV === 'test';
  const isCypress = window.Cypress !== undefined;

  if (detectUnitTestsOnly) {
    return isTest;
  }

  return isTest || isCypress;
};

export const isDevelopmentMode = (): boolean => {
  return process.env.NODE_ENV !== 'production';
};

/*
 * On-premise installations does not have "cloud-features" enabled. Examples of
 * cloud features: intercom, segment, request account delete...
 */
export const isOnPremise = (): boolean => window.IS_ON_PREM;

export const isPresentationMode = () => {
  return window.IS_PRESENTATION;
};
